import React, {JSX} from 'react';
import {useTheme} from 'styled-components';
import {Theme} from '../../../theme/lightTheme';
import {LinearGradient} from 'react-native-linear-gradient';
import {StyleProp, ViewStyle, Platform, View} from 'react-native';
import styled from 'styled-components/native';

const Container = styled.View<{withSeparator?: boolean}>`
  flex: 1;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  align-self: center;
`;

/**
 * The `GradientBackground` component represents a gradient background for a container.
 * It uses the `LinearGradient` component from the 'react-native-linear-gradient' library.
 *
 * @component
 *
 * @param {Object} props - The properties of the `GradientBackground` component.
 * @param {ViewStyle} [props.style] - Additional styles to apply to the container.
 *
 * @returns {JSX.Element} A React functional component representing a gradient background container.
 */
const GradientBackground = (props: {
  style?: StyleProp<ViewStyle>;
  isDarkMode?: boolean | null;
  withSeparator?: boolean;
}): JSX.Element => {
  // Retrieve the current theme using the `useTheme` hook
  const theme = useTheme() as Theme;

  // Render the container with a linear gradient background
  return (
    <Container
      withSeparator={props && props.withSeparator}
      style={props && props.style ? props.style : {}}
      pointerEvents={'none'}>
      {Platform.OS === 'web' ? (
        <View
          style={{
            flex: 1,
            backgroundColor: theme.header.startLinearGradient,
            //@ts-ignore
            backgroundImage: `linear-gradient(to right, ${theme.header.startLinearGradient}, ${theme.header.endLinearGradient})`,
          }}
        />
      ) : (
        <LinearGradient
          style={{
            flex: 1,
          }}
          colors={[
            theme.header.startLinearGradient,
            theme.header.endLinearGradient,
          ]}
        />
      )}
    </Container>
  );
};
GradientBackground.defaultProps = {
  style: {},
};
export default GradientBackground;
